import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { Fact } from '@/features/ai/api/ai';
import { apiRequest } from '@/lib/http';

export interface AssistantReply {
  id: string;
  question: string;
  answer: string;
  /** Os fatos citados na resposta. */
  evidence: Fact[];
  /** Todos os fatos que o troig buscou — "dados utilizados". */
  facts: Fact[];
  limitations: string[];
  followUps: string[];
  outOfScope: boolean;
  createdAt: string;
}

/** A tela em que a pessoa pergunta: "este produto" vira o produto aberto (módulos §11). */
export interface AssistantScreen {
  title: string | null;
  productId: string | null;
}

const historyKey = ['intelligence', 'assistant', 'history'] as const;

export function useAssistantHistory() {
  return useQuery({
    queryKey: historyKey,
    queryFn: () => apiRequest<AssistantReply[]>('/assistant/history'),
  });
}

export function useAsk() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: { question: string; screen?: AssistantScreen | null }) =>
      apiRequest<AssistantReply>('/assistant/ask', {
        method: 'POST',
        body: { question: input.question, screen: input.screen ?? null },
      }),
    onSuccess: (reply) =>
      queryClient.setQueryData<AssistantReply[]>(historyKey, (old) => [...(old ?? []), reply]),
  });
}
